export const QUIZ_DURATION_OPTIONS = [
  { minutes: 30, label: '30 Minutes' },
  { minutes: 45, label: '45 Minutes' },
  { minutes: 60, label: '60 Minutes' },
];
export const DEFAULT_QUIZ_DURATION_MINUTES = 30;

export const normalizeQuizDurationMinutes = (value) => {
  const n = Number(value);
  return QUIZ_DURATION_OPTIONS.some((opt) => opt.minutes === n) ? n : DEFAULT_QUIZ_DURATION_MINUTES;
};

export const quizDurationToSeconds = (value) => normalizeQuizDurationMinutes(value) * 60;

export const buildQuizPlayerUrl = ({ quizFileUrl, sessionId, durationMinutes, origin } = {}) => {
  const params = new URLSearchParams();
  if (quizFileUrl) params.set('quiz', quizFileUrl);
  if (sessionId) params.set('session', sessionId);
  params.set('duration', String(normalizeQuizDurationMinutes(durationMinutes)));
  const base = origin || (typeof window !== 'undefined' ? window.location.origin : '');
  return `${base}/?${params.toString()}`;
};
